import { render } from "./Inputs.vue?vue&type=template&id=2f5e3c4a&ts=true"
import script from "./Inputs.vue?vue&type=script&lang=ts"
export * from "./Inputs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__